import { base } from "../config/airtable.config";
import { MfsBase } from "../config/airtable.config";

  export const fetchAirtableDataFn = async ({
      tableName,
      fields,
      filterByFormula = "",
      maxRecords = 1000,
      dependencyState = null,
    }) => {
    try {
      let bufferData = [];
    await base(tableName)
      .select({
        maxRecords: 100,
        view: "Grid view",
        fields,
        filterByFormula,
      })
      // .eachPage(
      //   function page(records, _fetchNextPage) {
      //     records.map((item) => {
      //       //console.log("item",item)
      //       bufferData.push(item.fields);
      //       return { ...item.fields };
      //     });
      //   }
      // )    
      .eachPage((records, fetchNextPage) => {
        records.forEach((record) => {
        bufferData.push(record.fields);
        });
        fetchNextPage();
      });

      return bufferData;
    } catch (error) {
      throw error;
    }
  };    

  export const fetchMfsAirtableDataFn = async ({
    tableName,
    fields,
    filterByFormula = "",
    maxRecords = 1000,
    dependencyState = null,
  }) => {
  try {
    let bufferData = [];
  await MfsBase(tableName)
    .select({
      maxRecords: 100,
      view: "Grid view",
      fields,
      filterByFormula,
    })
    // .eachPage(
    //   function page(records, _fetchNextPage) {
    //     records.map((item) => {
    //       //console.log("item",item)
    //       bufferData.push(item.fields);
    //       return { ...item.fields };
    //     });
    //   }
    // )    
    .eachPage((records, fetchNextPage) => {
      records.forEach((record) => {
      bufferData.push(record.fields);
      });
      fetchNextPage();
    });

    return bufferData;
  } catch (error) {
    throw error;
  }
  };

  export const fetchAuctionAirtableDataFn = async ({
    tableName,
    fields,
    filterByFormula = "",
    maxRecords = 1000,
    dependencyState = null,
  }) => {
  try {
    let bufferData = [];
  await MfsBase(tableName)
    .select({
      maxRecords: 1000,
      view: "Grid view",
      fields,
      filterByFormula,
    })
    // .eachPage(
    //   function page(records, _fetchNextPage) {
    //     records.map((item) => {
    //       //console.log("item",item)
    //       bufferData.push(item.fields);
    //       return { ...item.fields };
    //     });
    //   }
    // )    
    .eachPage((records, fetchNextPage) => {
      records.forEach((record) => {
      bufferData.push(record.fields);
      });
      fetchNextPage();
    });

    return bufferData;
  } catch (error) {
    throw error;
  }
  };

  export const updateBidAirtableDataFn = async ({
    tableName,
    fields,
    id
  }) => {
  try {
    let bufferData = [];
   MfsBase(tableName)
    .update([{
      fields,
      id
    }], function(err, records) {
      if (err) {
        console.error(err);
        return;
      }
      records.forEach(function(record) {
        //console.log(record.get('ASSET_COST'));
      });
    })
    

    return bufferData;
  } catch (error) {
    throw error;
  }
  };


  export const updateMfsAirtableDataFn = async ({
    tableName,
    fields,
    id
  }) => {
  try {
    let bufferData = [];
   MfsBase(tableName)
    .update([{
      fields,
      id
    }], function(err, records) {
      if (err) {
        console.error(err);
        return;
      }
      records.forEach(function(record) {
        console.log(record.get('ASSET_COST'));
      });
    })
    

    return bufferData;
  } catch (error) {
    throw error;
  }
  };
